import React, {useMemo} from 'react'
import {config} from 'src/shared/config'

import {PromoAppLogo} from './PromoAppLogo'
import {classes} from './PromoBanner.classes'
import {BannerView} from './PromoBanner.consts'
import {PromoBannerProvider} from './PromoBanner.context'
import {usePromoBannerType} from './PromoBanner.hooks'
import type {PromoBannerContext, Props} from './PromoBanner.types'
import {usePopupScreen} from './promo-banner-popup-screen'
import {PromoBannerWithLeadButton} from './promo-banner-with-lead-button'
import {PromoBannerWithoutLeadButton} from './promo-banner-without-lead-button'

export const PromoBanner: React.FC<Props> = props => {
  const {isPopupScreenVisible, onOpenPopupScreen, onClosePopupScreen} = usePopupScreen()

  const bannerType = usePromoBannerType(props.lead_button)

  const context = useMemo<PromoBannerContext>(
    () => ({
      isPopupScreenVisible,
      onOpenPopupScreen,
      onClosePopupScreen,
    }),
    [isPopupScreenVisible, onOpenPopupScreen, onClosePopupScreen],
  )

  return (
    <PromoBannerProvider data={context}>
      <div className={classes.root}>
        <div className={classes.logo}>
          <PromoAppLogo brand={config.brand} />
        </div>
        <div className={classes.banner}>
          {bannerType === BannerView.WITH_LEAD_BUTTON ? (
            <PromoBannerWithLeadButton {...props} />
          ) : (
            <PromoBannerWithoutLeadButton {...props} />
          )}
        </div>
      </div>
    </PromoBannerProvider>
  )
}
